import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref, onMounted } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'MotorControls',
  props: {
    disabled: { type: Boolean, default: false }
  },
  emits: [
  'clickUp',
  'clickDown',
  'clickLeft',
  'clickRight',
  'holdUp',
  'holdDown',
  'holdLeft',
  'holdRight',
],
  setup(__props: any, { emit: __emit }) {

onMounted(() => {
  window.addEventListener(
    'mouseup',
    () => {
      stopSending()
    },
    false,
  )
  window.addEventListener(
    'touchend',
    () => {
      stopSending()
    },
    false,
  )
})

const emit = __emit



const intervalId = ref()

const startSending = (
  eventName: 'holdUp' | 'holdDown' | 'holdLeft' | 'holdRight',
) => {
  // Clear any existing interval
  stopSending()

  // Start a new interval that triggers the send message method every fifth of a second

  intervalId.value = setInterval(() => {
    emitEvent(eventName)
  }, 200)
}

const emitEvent = (
  eventName: 'holdUp' | 'holdDown' | 'holdLeft' | 'holdRight',
) => {
  emit(eventName)
}

const stopSending = () => {
  // Clear the interval
  clearInterval(intervalId.value)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['motorcontrols', { 'motorcontrols--disabled': __props.disabled }])
  }, [
    _createElementVNode("div", {
      class: "motorcontrols__arrow-up",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clickUp'))),
      onMousedown: _cache[1] || (_cache[1] = ($event: any) => (startSending('holdUp'))),
      onTouchstart: _cache[2] || (_cache[2] = ($event: any) => (startSending('holdUp'))),
      onMouseup: stopSending,
      onMouseleave: stopSending,
      onMouseout: stopSending,
      onTouchcancel: stopSending,
      onTouchend: stopSending
    }, null, 32),
    _createElementVNode("div", {
      class: "motorcontrols__arrow-left",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('clickLeft'))),
      onMousedown: _cache[4] || (_cache[4] = ($event: any) => (startSending('holdLeft'))),
      onTouchstart: _cache[5] || (_cache[5] = ($event: any) => (startSending('holdLeft'))),
      onMouseup: stopSending,
      onMouseleave: stopSending,
      onMouseout: stopSending,
      onTouchcancel: stopSending,
      onTouchend: stopSending
    }, null, 32),
    _createElementVNode("div", {
      class: "motorcontrols__arrow-right",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('clickRight'))),
      onMousedown: _cache[7] || (_cache[7] = ($event: any) => (startSending('holdRight'))),
      onTouchstart: _cache[8] || (_cache[8] = ($event: any) => (startSending('holdRight'))),
      onMouseup: stopSending,
      onMouseleave: stopSending,
      onMouseout: stopSending,
      onTouchcancel: stopSending,
      onTouchend: stopSending
    }, null, 32),
    _createElementVNode("div", {
      class: "motorcontrols__arrow-down",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('clickDown'))),
      onMousedown: _cache[10] || (_cache[10] = ($event: any) => (startSending('holdDown'))),
      onTouchstart: _cache[11] || (_cache[11] = ($event: any) => (startSending('holdDown'))),
      onMouseup: stopSending,
      onMouseleave: stopSending,
      onMouseout: stopSending,
      onTouchcancel: stopSending,
      onTouchend: stopSending
    }, null, 32)
  ], 2))
}
}

})